import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CallConfirm from '../CallConfirm/CallConfirm';
import ExitConfirm from '../ExitConfirm/ExitConfirm';
import PostChatSurvey from '../PostChatSurvey/PostChatSurvey';
import Chat from '../Chat/Chat';
import PreChat from '../PreChat/PreChat';
import AutoSignIn from '../AutoSignIn/AutoSignIn';
import { setPage } from '../../redux/actions/commonActions';
import { getUrlParam, getUrlElement } from '../../utils/common';
import { decodeMParam } from '../../utils/jwtUtils';

export const FrameAuto = () => {
    const { common, ui } = useSelector(state => state);

    const config = ui?.config?.attributes;
    const appAvayaSurvey = config?.appAvayaSurvey;
    const appCallUs = config?.appCallUs;

    const dispatch = useDispatch();


    const [stylePath, setStylePath] = useState('/css/dafabet.css');

    useEffect(() => {
        let brand = getUrlElement(6);
        if (brand == "mc-desktop") {
            brand = "dafabet";
        }
        setStylePath('/css/' + brand + '.css');
    }, [config]);

    useEffect(() => {
        var head = document.head;
        var link = document.createElement("link");

        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = stylePath;

        head.appendChild(link);

        return () => { head.removeChild(link); }
    }, [stylePath]);
        const page = common?.common?.page;
    
    // Get and decode the m parameter
    const encryptedMParam = getUrlParam('m');
    let mParam = null;
    let mUsername = null;
    let mEmail = null;
    let mReferer = null;
    
    // Only try to decode if m parameter exists
    if (encryptedMParam) {
        try {
            const decodedData = decodeMParam(encryptedMParam);
            if (decodedData) {
                mParam = decodedData.msg || null;
                mUsername = decodedData.username || null;
                mEmail = decodedData.email || null;
                mReferer = decodedData.referer || null;
            }
        } catch (error) {
            console.error('Error processing m parameter:', error);
        }
    }
    
    // Determine if this is a proactive chat
    const isProactive = (getUrlParam('proactive') == 1) ? true : false;

    return (
        <>


          <div style={{ display: common?.common?.page === 'exit-confirm' ? 'block' : 'none' }}>
            <ExitConfirm />
          </div>

          <div style={{ display: common?.common?.page === 'call-confirm' ? 'block' : 'none' }}>
            <CallConfirm />
          </div>

          <div style={{ display: common?.common?.page === 'chat' ? 'contents' : 'none' }}>
            <Chat mParam={mParam} />
          </div>

          <div style={{ display: common?.common?.page === 'auto-pre-chat' ? 'block' : 'none' }}>
            <AutoSignIn 
                    mParam={mParam} 
                    mUsername={mUsername} 
                    mEmail={mEmail} 
                    mReferer={mReferer} />
          </div>

        </>
    );
};

export default FrameAuto;
